import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0496d18a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=0496d18a&prod&lang=stylus"
import style1 from "./index.vue?vue&type=style&index=1&id=0496d18a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496d18a",
  null
  
)

export default component.exports